// Define the month names for different languages
const monthNames = {
  en: [
    'Hamal',
    'Sawr',
    'Jawza',
    'Saratan',
    'Asad',
    'Sonbola',
    'Mizan',
    'Aqrab',
    'Qaws',
    'Jadi',
    'Dalwa',
    'Hoot',
  ], // English transliterations of Dari months
  dr: ['حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس', 'جدی', 'دلو', 'حوت'],
} as const;

type SupportedLanguages = keyof typeof monthNames; // 'en' | 'dr'

// Reusable function to get the month name
export function GetMonthName(monthNumber?: any, local?: string): string {
  let language = '';
  if (local) {
    language = local;
  } else {
    language = localStorage.getItem('i18nextLng') as SupportedLanguages;
  }

  // Validate monthNumber
  if (!monthNumber || monthNumber < 1 || monthNumber > 12) {
    return 'Invalid month';
  }

  // Use the detected language, fallback to English if not available
  const selectedLanguage = language in monthNames ? language : 'en';

  // Type assertion here to tell TypeScript that selectedLanguage is definitely a key of monthNames
  return monthNames[selectedLanguage as keyof typeof monthNames][monthNumber - 1];
}
